import { useContext, useEffect } from "react";
import { EventsCalendar } from "../../web/components/events/EventsCalendar";
import { EnterpriseContext } from "./EnterpriseContext";
import { Card, CardBody, Col, Row } from "reactstrap";
import VTCMenu from "../../web/components/VTCMenu";
import Breadcrumbs from "../../web/components/Breadcrumbs";
import truckyService from "../../common/services/trucky-service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import BoxDynamicAd from "../../ads/BoxDynamicAd";

export default function CompanyEventsCalendar({ container }) {
  const { globalContext } = useContext(EnterpriseContext);

  useEffect(() => {
     truckyService.setDocumentTitle('Company Events Calendar');
  }, []);
  
  return (
    <Row noGutters>
      <Col sm="auto">
        <VTCMenu
          active={"/company/events/calendar"}
          container={container}
        ></VTCMenu>
      </Col>
      <Col>
        <Card>
          <CardBody>
            <Breadcrumbs
              breadcrumbs={[
                {
                  to: "/vtchub",
                  title: container.localeManager.strings.vtcHub,
                },
                {
                  title: container.localeManager.strings.companyEvents,
                },
                {
                  title: container.localeManager.strings.calendar,
                },
              ]}
            ></Breadcrumbs>
            <div className="page-hero mb-4">
              <span className="page-hero-icon">
                <FontAwesomeIcon icon="calendar" className="mx-0" />
              </span>
              <div className="flex-1">
                <h1 className="page-hero-title mb-0">{container.localeManager.strings.companyEvents}</h1>
              </div>
            </div>
            <div>
              <EventsCalendar
                container={container}
                company_id={globalContext.company.id}
              />
            </div>
          </CardBody>
        </Card>
      </Col>
      <aside className="ad-column-placeholder">
        {!window.overwolf && (
          <BoxDynamicAd container={container} className="my-3" />
        )}
      </aside>
    </Row>
  );
}
